import { useState, useRef, useCallback } from "react";
import { Check, ChevronsRight } from "lucide-react";

export function SlideToReveal({ onReveal, label = "Dra her for å aktivere kupongen", testId = "slide-to-reveal" }) {
  const trackRef = useRef(null);
  const HANDLE = 56;
  const PAD = 4;
  const [x, setX] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [done, setDone] = useState(false);

  const getMax = useCallback(() => {
    const t = trackRef.current;
    if (!t) return 0;
    return t.offsetWidth - HANDLE - PAD * 2;
  }, []);

  const moveTo = useCallback((clientX) => {
    const t = trackRef.current;
    if (!t) return;
    const rect = t.getBoundingClientRect();
    let nx = clientX - rect.left - PAD - HANDLE / 2;
    const max = getMax();
    nx = Math.max(0, Math.min(nx, max));
    setX(nx);
  }, [getMax]);

  const onPointerDown = (e) => {
    if (done) return;
    setDragging(true);
    e.currentTarget.setPointerCapture?.(e.pointerId);
    moveTo(e.clientX);
  };

  const onPointerMove = (e) => {
    if (!dragging || done) return;
    moveTo(e.clientX);
  };

  const onPointerUp = () => {
    if (done) return;
    setDragging(false);
    const max = getMax();
    if (x >= max - 16) {
      setX(max);
      setDone(true);
      onReveal();
    } else {
      setX(0);
    }
  };

  const max = getMax();
  const pct = max > 0 ? x / max : 0;

  return (
    <div
      ref={trackRef}
      className="relative mx-auto h-16 w-full max-w-sm select-none overflow-hidden rounded-full border border-[#D4AF37]/30 bg-[#1A1715]"
      data-testid={testId}
    >
      {/* fill */}
      <div
        className="absolute inset-y-0 left-0 rounded-full bg-[#D4AF37]/15"
        style={{ width: `${x + HANDLE + PAD}px` }}
      />
      {/* label */}
      <div
        className="pointer-events-none absolute inset-0 flex items-center justify-center gap-2 text-sm font-medium uppercase tracking-wide text-[#A8A29E]"
        style={{ opacity: done ? 0 : 1 - pct * 1.3 }}
      >
        <ChevronsRight className="h-4 w-4 animate-pulse" />
        {label}
      </div>
      {/* handle */}
      <button
        type="button"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        aria-label={label}
        data-testid={`${testId}-handle`}
        className={`absolute top-1/2 flex h-14 w-14 -translate-y-1/2 items-center justify-center rounded-full bg-[#D4AF37] text-[#1A1715] shadow-lg ${
          dragging ? "cursor-grabbing" : "cursor-grab"
        } ${done ? "" : "touch-none"}`}
        style={{ left: `${PAD + x}px`, transition: dragging ? "none" : "left 0.25s ease-out" }}
      >
        {done ? <Check className="h-6 w-6" /> : <ChevronsRight className="h-6 w-6" />}
      </button>
    </div>
  );
}
